import React, { useState, useEffect} from 'react';
import "../assets/css/styles.table.css"
import Layout from './Layout';
//for table
import Box from '@mui/material/Box';
import { Typography, Modal, 
} from '@mui/material';
import ConfirmationButton from '../components/ConfirmationButton'
import DynamicDataGridComponent from '../components/DynamicDataGrid'
import {useStatusHookList} from '../hook/StatusListHook'
import GridNumberPaging from '../components/GridNumberPaging.js'
import Bindcomponent from '../utils/bindcomponent.js';
const StatusList = () => {
 
const {setName, setConfirmStatusOpen,  setmessage, setTipe, rows, columns, AddStatus,message,tipe,roleAccess ,confirmStatusOpen,name,idStatus,AddProjectData,role} = useStatusHookList();
  
return (
    <>
     <Layout message={message} setmessage={setmessage} tipe={tipe} settipe={setTipe}>
      <div className='pd' ><b>STATUS LIST</b></div>
      <div className="pd">
        <div style={{marginBottom:15}}>
          {role.toUpperCase() == "SUPERADMIN".toUpperCase() && (
            <button className='btn btn-success' disabled={!roleAccess.CREATE} onClick={AddProjectData}>Add record</button>
          )

          }
          
        </div>
  
      <Box sx={{ width: 1 }} >
        <Box sx={{ height: 550 }} >
           <Bindcomponent component='GridNumberPaging' customcolumns={columns} rows={rows} name={"statusgrid"} rowid={"id"}></Bindcomponent>  
           
        </Box>
    </Box>
    </div>

    <Modal
        open={confirmStatusOpen}
        onClose={() => setConfirmStatusOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className='modals-delegasi' >
          
          <Typography id="modal-modal-description">
            <form onSubmit={AddStatus} role="form" id="myform2">
            <div class="row">
            <div class="col-md-12">
            <label>Name</label>
            <input
                      type="text"
                      className="form-control"
                      placeholder="Task Name"
                      required
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
            </div>
             </div>
         
         <hr></hr>
         <div class="row">
            <div class="col-md-12" style={{textAlign:'right'}}>
            <div style={{marginTop:5,marginBottom:5}}>
              <Bindcomponent component='ConfirmationButton' classname='btn btn-primary' text="Do you want save this data?" type="submit" formid="myform2" id="btnSubmit1">
                    {idStatus ? "UPDATE" : "ADD"}
              </Bindcomponent>
            {/* <ConfirmationButton classname='btn btn-primary' text="Do you want save this data?" type="submit" formid="myform2" id="btnSubmit1">
                {idStatus ? "UPDATE" : "ADD"}
            </ConfirmationButton> */}
 
                 </div>
            </div>
           
         </div>
         </form>
         
          </Typography>
        </Box>
</Modal>

 
  </Layout>

    </>
  );
};

export default StatusList;